import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { UserProfile } from 'src/app/pages/my-account/interfaces/company-settings.interface';
import { MyAccountService } from 'src/app/pages/my-account/services/my-acount.service';
import { PublicRequestService, publicRoutes } from 'src/app/services/public-request.service';
import { BrandingInfo } from 'src/app/models/branding-info.model';

export interface ContactServiceData {

  email: string;
  phoneNumber: string;

}

const ContactDataDictionary: Record<string, ContactServiceData> = {

  esp: {
    email: "soporte@cafler.com",
    phoneNumber: "+34 91 290 12 24"
  },
  gbr: {
    email: "operationsuk@cafler.com",
    phoneNumber: "+44 20 4572 7931"
  },
  fra: {
    email: "operationsfrance@cafler.com",
    phoneNumber: "+33 1 89 71 38 09"
  }

};

export const countryCodeAlpha2ToAlpha3: Record<string, string> = {

  ES: 'esp',
  GB: 'gbr',
  FR: 'fra',

};

@Component({
  selector: 'app-support-modal',
  templateUrl: './support-modal.component.html',
  styleUrls: ['./support-modal.component.scss']
})

export class SupportModalComponent {

  user: UserProfile | null = null;
  contactServiceData: ContactServiceData = {} as ContactServiceData;
  private defaultCode = 'esp';
  private okMobilityName = 'OkMobility';
  Loading: boolean = false;
  isPublicRoute: boolean = false;

  brandingId: string = "";
  brandingInfo: BrandingInfo | null = null;

  modalTitleKey: string = '';
  modalMessageKey: string = '';
  organizationName: string = '';
  workingHoursKey: string = 'workingHours';

  constructor(
    private bsModal: BsModalRef,
    private MyAccountService: MyAccountService,
    private router: Router,
    private PublicRequestService: PublicRequestService
  ) { }

  async ngOnInit() {

    this.isPublicRoute = this.PublicRequestService.isPublicRoute();
    this.Loading = true;


    if (this.brandingId && this.brandingInfo?.PhoneNumber && this.brandingInfo?.Email) {

      this.contactServiceData = {
        phoneNumber: this.brandingInfo.PhoneNumber,
        email: this.brandingInfo.Email
      };

    } else {

      await this.loadDefaultContactInfo();

    }

    this.setModalTitleData();
    this.workingHoursKey = (this.brandingInfo?.OrganizationName === this.okMobilityName) ? 'customOkMobilityWorkingHours' : 'workingHours';
    this.Loading = false;
  }

  private setModalTitleData(): void {
    if (this.brandingId && this.brandingInfo?.OrganizationName) {

      this.modalTitleKey = 'contactWith';
      this.modalMessageKey = 'callUs_publicRoute_custom';
      this.organizationName = this.brandingInfo.OrganizationName;

    } else {

      this.modalTitleKey = 'contactUs';
      this.modalMessageKey = 'callUs';
      this.organizationName = '';

    }
  }

  private async loadDefaultContactInfo(): Promise<void> {
    if (!this.isPublicRoute) {
      this.user = this.MyAccountService.getUserDetailLocal();

      if (!this.user) {
        this.user = await this.MyAccountService.getUserDetail().toPromise() ?? null;
      }

      if (this.user) {
        this.contactServiceData = this.getContactData(this.user?.AccountRegionIsoCode!);
      } else {
        await this.setNativeCode();
      }

    } else {
      await this.setNativeCode();
    }
  }

  async setNativeCode() {
    const key = await this.getAlpha3RegionCode();
    this.contactServiceData = this.getContactData(key as string)
  }

  getContactData(regionCode?: string): ContactServiceData {
    return ContactDataDictionary[regionCode?.toLowerCase() ?? this.defaultCode];
  }

  async getAlpha3RegionCode(): Promise<string | null> {
    try {

      const res = await fetch('https://ipapi.co/json');
      const data = await res.json();
      let alpha2 = data.country?.toUpperCase();
      if (alpha2 !== 'ES' && alpha2 !== 'FR') {
        alpha2 = 'GB';
      }
      return countryCodeAlpha2ToAlpha3[alpha2] || null;

    } catch (error) {

      return null;

    }
  }

  onClose(): void {
    this.bsModal.hide();
  }
}
